$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('scenario-rv-video')) {
    customElements.define(
      'scenario-rv-video',
      class ScenarioRvVideo extends HTMLElement {
        swiper = null;
        constructor() {
          super();
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const $root = $(this);
          const _this = this;
          const $videoItems = $root.find('.video_item');
          $videoItems.on('click', function (event) {
            _this.handlePlayClick(event);
          });

          const $mySwiper = this.querySelector('.scenario-rv-video_swiper');
          const $scrollbarDom = this.querySelector('.scenario-rv-video-scrollbar');
          const $prevDom = this.querySelector('.scenario-rv-video_prev');
          const $nextDom = this.querySelector('.scenario-rv-video_next');

          this.swiper = new Swiper($mySwiper, {
            slidesPerView: 4,
            spaceBetween: 16,
            navigation: {
              nextEl: $nextDom,
              prevEl: $prevDom,
            },
            scrollbar: {
              el: $scrollbarDom,
              draggable: true,
            },
            breakpoints: {
              1201: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
              0: {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
              },
            },
            on: {
              slideChange: function () {
                if (this.isBeginning) {
                  $($prevDom).removeClass('flex').addClass('hidden');
                } else {
                  $($prevDom).removeClass('hidden').addClass('flex');
                }
                if (this.isEnd) {
                  $($nextDom).addClass('hidden');
                } else {
                  $($nextDom).removeClass('hidden');
                }
              },
            },
          });
        }

        handlePlayClick(event) {
          const $video = $(event.currentTarget);
          console.log($video);
          const modalId = $video.data('id');
          if (!this.modalManager.getModal(modalId)) {
            this.modalManager.register(modalId, {
              onOpen: (container) => {
                const iframe = $(container).find('iframe');
                const currentSrc = iframe.attr('src');
                const newSrc = currentSrc + '&autoplay=1&playsinline=1&mute=1&enablejsapi=1';
                // 使用延迟加载确保 iframe 已经完全加载
                setTimeout(() => {
                  iframe.attr('src', newSrc);
                  try {
                    const iframeElement = iframe[0];
                    iframeElement.contentWindow.postMessage(
                      JSON.stringify({
                        event: 'command',
                        func: 'playVideo',
                      }),
                      '*'
                    );
                  } catch (error) {
                    console.error('Failed to post play message:', error);
                  }
                }, 0);
              },
              onClose: (container) => {
                const iframe = $(container).find('iframe');
                const currentSrc = iframe.attr('src');
                iframe.attr('src', currentSrc.replace('&autoplay=1&playsinline=1&mute=1&enablejsapi=1', ''));
                $(this).off('click', this.handlePlayClick.bind(this));
              },
            });
          }
          this.modalManager.open(modalId);
        }
      }
    );
  }
});
